import { render } from "./CancerEpiChat.vue?vue&type=template&id=1a0b214e&scoped=true"
import script from "./CancerEpiChat.vue?vue&type=script&lang=js"
export * from "./CancerEpiChat.vue?vue&type=script&lang=js"

import "./CancerEpiChat.vue?vue&type=style&index=0&id=1a0b214e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0b214e"]])

export default __exports__